import { RouteRecordRaw } from 'vue-router';

export const homepageRoute: RouteRecordRaw = {
  path: '/',
  name: 'Homepage',
  component: () => import('@/modules/Homepage/views/HomepageView.vue'),
  meta: {
    titleLocalizationKey: 'SKILLS.apps',
  },
};
